
import './styles.css';

import QuestionsTransactionsTable from '../../../questionsTransactionsTable';

export default function InstructorTransactionsModal({
  onCloseButtonClick,
  tableHeaders,
  transactionsData,
  // Defaults preserve existing call sites (double-entry / review-
  // session). Principles overrides to "Business Activity" and hides
  // the per-data-column header text (e.g. "Impact on Profits") while
  // keeping the tableColumnHeader cell visible.
  tableColumnHeader = 'Transactions',
  hideColumnHeaders = false,
  modalClassName = '',
}) {

  return (
    <div className="modal-overlay" onClick={onCloseButtonClick}>
      <div className={`modal instructor-decision-insights-modal ${modalClassName}`} onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onCloseButtonClick}></button>
        <QuestionsTransactionsTable
          tableColumnHeader={tableColumnHeader}
          tableHeaders={tableHeaders}
          tableData={transactionsData}
          hideColumnHeaders={hideColumnHeaders}
        />
      </div>
    </div>
  );
}
